<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>End-User Licence Agreement</h6>
    <div class="eula-accepted-info body-1">
      <mat-icon>info_outline</mat-icon>
      <div class="accepted-info-text">
        Accepted on {{ currentUser.eulaApprovedDateTime | dateepoch: timezone }} by {{ currentUser.eulaApprovedBy }}
      </div>
    </div>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <mat-divider />
  <div class="eula subtitle-2" [innerHTML]="eulaContent()"></div>
  <mat-divider />
</div>
